import React from "react";
import BaseModal from "../../../global/components/Modals/BaseModal";
import ImageGuidelines from "./ImageGuidelines";
import { CREATE_APPEARANCE } from "../../../constants/enrolledAppearanceConstants";
import Guideline1 from "../../../assets/EnrolledAppearanceGuidelines/guideline1.png";
import Guideline2 from "../../../assets/EnrolledAppearanceGuidelines/guideline2.png";
import Guideline3 from "../../../assets/EnrolledAppearanceGuidelines/guideline3.png";
import Guideline4 from "../../../assets/EnrolledAppearanceGuidelines/guideline4.png";
import Guideline5 from "../../../assets/EnrolledAppearanceGuidelines/guideline5.png";
import Guideline6 from "../../../assets/EnrolledAppearanceGuidelines/guideline6.png";

const fileTypes = ["JPG", "PNG", "JPEG"];
const doCaptions = [CREATE_APPEARANCE.DO_CAPTION_1, CREATE_APPEARANCE.DO_CAPTION_2];
const dontCaptions = [CREATE_APPEARANCE.DONT_CAPTION_1, CREATE_APPEARANCE.DONT_CAPTION_2, CREATE_APPEARANCE.DONT_CAPTION_3];
const doImages = [Guideline1, Guideline2];
const dontImages = [Guideline3, Guideline4, Guideline5];

const ImageGuidelinesModal = ({ opened, onClose }) => (
  <BaseModal
    opened={opened}
    onClose={onClose}
    width="560px"
    hideButtons={true}
    hideCloseButton={false}
    closeButtonText={CREATE_APPEARANCE.CLOSE}
    onBack={onClose}
  >
    <div data-testid="image-guidelines-modal">
      <ImageGuidelines supportedTypes={fileTypes} doCaptions={doCaptions} dontCaptions={dontCaptions} doImages={doImages} dontImages={dontImages} />
    </div>
  </BaseModal>
);

export default ImageGuidelinesModal;
